// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var ActivationsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ActivationsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create activation with given data
     *
     * @since 1.0.0
     *
     * @param data New activation setting data
     */
    ActivationsService.prototype.create = function (data) {
        return this.apiService.apiCall("POST", "activations", data, undefined, undefined, undefined, "v2");
    };
    /**
     * Get activations list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    ActivationsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "activations", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get given activationId data from back-end
     *
     * @since 1.0.0
     *
     * @param activationId ID of the role to get
     */
    ActivationsService.prototype.get = function (activationId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "activations/" + activationId, undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update activation with given activationId with given activation data
     *
     * @since 1.0.0
     *
     * @param activationId ID of role to update
     * @param data New activation's data
     */
    ActivationsService.prototype.update = function (activationId, data) {
        return this.apiService.apiCall("PUT", "activations/" + activationId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Update activation with given activationId with given activation data
     *
     * @since 1.0.0
     *
     * @param activationId ID of role to update
     * @param data New activation's data
     */
    ActivationsService.prototype.updateFields = function (activationId, data) {
        return this.apiService.apiCall("PATCH", "activations/" + activationId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Delete permanently a activation
     *
     * @since 1.0.0
     *
     * @param activationId ID of the activation
     */
    ActivationsService.prototype.delete = function (activationId) {
        return this.apiService.apiCall("DELETE", "activations/" + activationId, undefined, undefined, undefined, undefined, "v2");
    };
    ActivationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ActivationsService_Factory() { return new ActivationsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: ActivationsService, providedIn: "root" });
    return ActivationsService;
}());
export { ActivationsService };
